// extracted by css-extract-rspack-plugin
export default {"actionContainer":"actionContainer-edZL68","item":"item-Gzf5pG","popoverItem":"popoverItem-iuw40i","text":"text-KXmk7_"};